<template>
	<div class="content_index" v-if="vshow==true">
		<div class="kv_box">
		    <div class="kv">
		        <div class="swiper-container swiper1">
		            <div class="swiper-wrapper">
		                <div class="swiper-slide" v-for="(item,index) in kvList" :key="index">
		                   <img class="w100" :src="item.show_img" alt="">
						   <div class="text_des">
							    Deliver high wear performance, <br/>							    Reduce your maintenance cost,<br/>								Bring down your shutdown time.
								<router-link to="/contact" class="btn_contact">Learn More</router-link>
						   </div>
		    				
		                </div>
		    			
		            </div>
		            <div class="swiper-pagination"></div>
		    		<div class="swiper-button-prev"></div>
		    		<div class="swiper-button-next"></div> 
		        </div>
		    </div> 
		</div>
		<div class="tips2">
			<!-- <img src="@/assets/images/index/tips2_bg.jpg" alt="" class="w100"> -->
			<div class="container">
				<div class="text_box">
					<h3>About Us</h3>
					<p>
                        Hisan (Tianjin) Co., Ltd. is a high-tech company specializing in the production of chromium carbide overlay wear resistant plates, wear resistant ceramics, wear resistant castings, overlay wear pipes, welding wires and abrasion resistant steel plates. Our products are resistant to wear, erosion, high temperature, stress, impact and other factors that cause wear. Over the years, Hisan has gathered experienced and skilled professionals from mining, cement, material handling, thermal power and other fields. With the leading R & D team, we continuously break through technical barriers, improve products, and develop more professional wear resistant solutions to make products  much more durable. Hisan is constantly striving to meet with the wear needs of various working conditions!
					</p>
					<ul>
						<li>
							<p>Export Country</p>
							<span><CountTo  ref="refcountofore1" :duration="1000" :start-val="_startVal" :end-val="25" :decimals="0"></CountTo>+</span>
						</li>
						<li>
							<p>Technicians & R&D</p>
							<span><CountTo ref="refcountofore2" :duration="1000" :start-val="_startVal" :end-val="18" :decimals="0"></CountTo>+</span>
						</li>
						<!-- <li>
							<p>Cooperative Client </p>
							<span><CountTo ref="refcountofore3" :duration="1000" :start-val="_startVal" :end-val="200" :decimals="0"></CountTo>+</span>
						</li> -->
						<li>
							<p>Area</p>
							<span><CountTo  ref="refcountofore4" :duration="1000" :start-val="_startVal1" :end-val="11000" :decimals="0"></CountTo></span>m<sup>2</sup>
						</li>
					</ul>
				</div>
					
			</div>
			
		</div>
		<div class="tips3">
			
			<div class="container">
				<h3>Product Range</h3>
				<ul class="tips3List">
					<li v-for="(item,index) in tips3List" :key="index" >
						<img :src="item.image" alt="" class="tisp3_img"/>
						<div class="text_bottom">
							<div class="tips3_text">
								<h4>{{item.title}}</h4>
								<p>{{item.overview}}</p>
							</div>
							<div class="buttom" @click="golinkto(item.atitle)">
								<img src="@/assets/images/index/jt_r.png" alt="" />
								<span>View Products</span>
							</div>
						</div>
					</li>
				</ul>	
			</div>
			
		</div>
		<div class="tips_boxz">
			
			<div class="tips4">
				
				<div class="container">
					<div class="text_box">
						<h3>Applications</h3>
							
						<div class="swiper-container swiper5">
						    <div class="swiper-wrapper">
						        <div class="swiper-slide" @click="golink(item.show_link)" v-for="(item,index) in tips4List" :key="index" >
									<img :src="item.show_img" alt="" class="w100"/>
									<p>{{item.show_name}}</p>
						        </div>
								
						    </div>
						    
						</div>
					</div>
				</div>
			</div>
			<div class="tips5">
				<div class="container">
					<h3>Equipment Display</h3>
					<div class="img_box">
						<div class="tips5_1 tips5_img">
							<div class="swiper-container swiper2">
								<div class="swiper-wrapper">
									<div class="swiper-slide"  v-for="(item,index) in tipslunbo" :key="index" v-if="item.sort<10">
									   <img class="w100" :src="item.show_img" alt=""/>
                                       <p>{{item.show_name}}</p>
									</div>
									
								</div>
								
							</div>
							
						</div>
						<div class="tips5_2">
							<div class="tips5_img tips5_img_top">
								<div class="swiper-container swiper3">
									<div class="swiper-wrapper">
										<div class="swiper-slide"  v-for="(item,index) in tipslunbo" :key="index" v-if="item.sort<20&&item.sort>10">
										   <img class="w100" :src="item.show_img" alt=""/>
                                           <p>{{item.show_name}}</p>
										</div>
										
									</div>
									
								</div>
								
							</div>
							<div class="tips5_img">
								<div class="swiper-container swiper4">
									<div class="swiper-wrapper">
										<div class="swiper-slide"  v-for="(item,index) in tipslunbo" :key="index" v-if="item.sort<30&&item.sort>20">
										   <img class="w100" :src="item.show_img" alt=""/>
                                           <p>{{item.show_name}}</p>
										</div>
										
									</div>
									
								</div>
								
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="tips7">
				<div class="container">
					
					<div class="text_box">
						<h3>Our Honor</h3>
                        <p>{{HonorText}}</p>
						<div class="swiper-container swiper6">
						    <div class="swiper-wrapper">
						        <div class="swiper-slide" v-for="(item,index) in Honorlb" :key="index" >
									<img :src="item.show_img" alt="" class="w100"/>
									<!-- <p>{{item.show_name}}</p> -->
						        </div>
								
						    </div>
						    
						</div>
                        <a class="lear_more" href="/cco">Lear more</a>
					</div>
				</div>
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div> 
			</div>
            <div class="tips6">
				<img src="@/assets/images/index/tips6_bg.jpg" alt="" class="w100" style="opacity: 0;">
				<div class="container">
					
					<div class="text_box">
						<h3>Why Choose Us?</h3>
						<ul>
							<li v-for="(item,index) in tips6List" :key="index" >
								<img :src="item.imgsrc" alt="" class=""/>
								<h4>{{item.name}}</h4>
								<p>{{item.text}}</p>
							</li>
						</ul>	
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import CountTo from 'vue-count-to';
	import Swiper from 'swiper';
	import axios from 'axios';
	export default {
		components: {
			CountTo,
		},
		data() {
			return {
				vshow:false,
				startOnMount:false,
				_startVal:0,
                HonorText:'',
				_startVal1:10000,
				kvList:[
					
				    
				],
                Honorlb:[
					
				    
				],
				tips3List:[
					
				    
				    
				],
				tips4List:[
					
				],
				tips6List:[
					{
						imgsrc:require('@/assets/images/index/tips6_1.png'),
						name:'Persuit of Quality',
						text:"High quality is our obligation! Hisan's products are all produced under tightly controlled parameters and would be inspected before leaving our plants.",
					},
					{
						imgsrc:require('@/assets/images/index/tips6_2.png'),
						name:'Support Service',
						text:'Great Service is our mission! Hisan provides quick reactions to your queries within 24 hours. We are commited to providing exceptional customer support.',
					},
					{
						imgsrc:require('@/assets/images/index/tips6_3.png'),
						name:'Expertise',
						text:'We are a gorup of professional people with 10 years of extensive industry experience. Hisan assists its clients with proper material selection, industrial design and installation.',
					},
				],
			}
		},
		methods:{
			golink(cid){
				const routeUrl = this.$router.resolve({
					path: "/appliction",
					query: { cid: cid },
				});	
				window.open(routeUrl.href, "_self");
			},
			golinkto(link){
				const routeUrl = this.$router.resolve({
					path: link,
					
				});	
				window.open(routeUrl.href, "_self");
			},
			handleScrollx() {
				const currentHeight = window.pageYOffset;
				console.log(currentHeight);
				if(currentHeight>400){
					
					this.$refs.refcountofore1.start();
					this.$refs.refcountofore2.start();
					// this.$refs.refcountofore3.start();
					this.$refs.refcountofore4.start();
					// this.starCount()
				}
			}
		},
		mounted(){
			var that = this;
			
			
			
            axios({
				method: 'post',
				url:`${this.$apiYf}/indexlunboapi.php`,
				data: {
					cid:1
				},
				headers: {'Content-Type': 'multipart/form-data'},
			}).then(res=>{
			    if(res.data.error==0){
					that.kvList=res.data.lunboinfo;
					
					axios({
						method: 'post',
						url:`${this.$apiYf}/anlistapi.php?catid=10`,
						
						headers: {'Content-Type': 'multipart/form-data'},
					}).then(res=>{
					    that.tips3List =res.data.productc_list
					});
                    
					axios({
						method: 'post',
						url:`${this.$apiYf}/indexlunboapi.php?cid=16`,
						
						headers: {'Content-Type': 'multipart/form-data'},
					}).then(res=>{
					    that.tips4List =res.data.lunboinfo
					    axios({
					    	method: 'post',
					    	url:`${this.$apiYf}/indexlunboapi.php?cid=17`,
					    	
					    	headers: {'Content-Type': 'multipart/form-data'},
					    }).then(res=>{
					        that.tipslunbo =res.data.lunboinfo
					        that.vshow = true;
                            axios({
                            	method: 'post',
                            	url:`${this.$apiYf}/indexlunboapi.php?cid=22`,
                            	
                            	headers: {'Content-Type': 'multipart/form-data'},
                            }).then(res3=>{
                                console.log(res3)
                                that.HonorText=res3.data.show_text;
                                that.Honorlb = res3.data.lunboinfo;
                                that.$nextTick(() => {
                                    that.swiper6 = new Swiper ('.swiper6', {
                                        loop: true, 
                                        autoplay: false,
                                        spaceBetween: 25,
                                        navigation: {
                                        	nextEl: '.tips7 .swiper-button-next',
                                        	prevEl: '.tips7 .swiper-button-prev',
                                        	clickable: true,
                                        },
                                        autoHeight:true,
                                        centeredSlides: true,
                                        slidesPerView: 5,
                                    });
                                })
                            })
					        that.$nextTick(() => {
					           that.kvSwiper = new Swiper ('.kv .swiper1', {
					           	effect : 'fade',
					           	loop: false, 
					           	autoplay: {
					           		delay: 3000,
					           		disableOnInteraction: false,
					           	},
					           	pagination: {
					           		el: '.kv .swiper-pagination',
					           		clickable: true,
					           	},
					           	navigation: {
					           		nextEl: '.kv .swiper-button-next',
					           		prevEl: '.kv .swiper-button-prev',
					           		clickable: true,
					           	},
					           	speed: 500,
					           	roundLengths : true, 
					           	observer:true,
					           	observeParents:true,
					           	observeSlideChildren:true,
					           	calculateHeight: true,
					           	
					           });
					            that.swiper2 = new Swiper ('.swiper2', {
					            	loop: true, 
                                    speed:4000,
					            	autoplay: {
					            		delay: 0,
					            		disableOnInteraction: false,
					            	},
					            	mousewheel: true,
					            	direction: "vertical",
					            	height:$(".tips5_1").width()/680*710,
					            	autoHeight:true,
					            	centeredSlides: true,
					            	slidesPerView: 1,
					            });
					            that.swiper3 = new Swiper ('.swiper3', {
					            	loop: true, 
                                    speed:4000,
					            	autoplay: {
					            		delay: 0,
					            		disableOnInteraction: false,
					            	},
					            	mousewheel: true,
					            	direction: "vertical",
					            	height:$(".tips5_img_top").width()/680*335,
					            	autoHeight:true,
					            	centeredSlides: true,
					            	slidesPerView: 1,
					            });
					            that.swiper4 = new Swiper ('.swiper4', {
					            	loop: true, 
                                    speed:4000,
					            	autoplay: {
					            		delay: 0,
					            		disableOnInteraction: false,
					            	},
					            	mousewheel: true,
					            	direction: "vertical",
					            	height:$(".tips5_img_top").width()/680*335,
					            	autoHeight:true,
					            	centeredSlides: true,
					            	slidesPerView: 1,
					            });
					            that.swiper5 = new Swiper ('.swiper5', {
					                loop: true, 
					                autoplay: {
					                    delay: 3000,
					                    disableOnInteraction: false,
					                },
					                spaceBetween: 30,
					                
					                autoHeight:true,
					                centeredSlides: true,
					                slidesPerView: 3,
					            });
					            
					        })
					    });
					    
					});
					
				}
			    
			
			});
			window.addEventListener('scroll', this.handleScrollx, true);
			window.scroll(function(){
				var pagetop= $(window).scrollTop();
			})
			
		},
		
	}
</script>

<style lang="scss">
	.content_index{
        .kv_box {
            width: 100%; overflow: hidden;position: relative; 
            
        }
        .kv {
            width: 100%;overflow: hidden;
        	.swiper-button-prev{left: 10%;}
        	.swiper-button-next{right: 10%;}
        	.swiper-button-prev,.swiper-button-next{
        		z-index: 999;
        		position: absolute;top:calc(50% - 35px);z-index: 9;
        		border: solid 3px rgba(255, 255, 255, 0.8);width: 70px;height: 70px;text-align: center;line-height: 70px;border-radius: 50%;
        	}
        	.swiper-button-prev::after{
        		
        		content: "prev"!important;font-family: 'swiper-icons';
        	}
        	.swiper-button-next::after{
        		content: "next"!important;font-family: 'swiper-icons';
        	}
        	
            .swiper-container {
                width: 100%; height: 100%; overflow: hidden; position: relative;
                .swiper-wrapper {
                    width: 100%; height: 100%;
                    .swiper-slide {
                        width: 100%; height: 100%; overflow: hidden;
        				.text_des{position: absolute;text-shadow: 4px 4px 6px rgba(0, 0, 0, 0.5);
        				left:calc(15% + 40px);top:calc(50% - 140px);font-size: 48px;color:#fff;line-height: 1.5;}
        				.btn_contact{width:200px;height:50px;margin-top: 30px;display: block;
        				font-size:24px;text-align: center;line-height: 50px;color:#fff;border: solid 1px rgba(255,255,255,0.4);}
        				img{
        					transition:1s linear 0.5;
        					transform:scale(1.1,1.1);
        					width: 100%;
        					height: calc(100vh - 120px);
        					max-height: 1080px;
        					object-fit: cover;
        					
        				}
                        &.swiper-slide-active{
        					img{
        						transition:2s linear;
        						transform:scale(1,1);
        						width: 100%;
        						height: calc(100vh - 120px);
        						max-height: 1080px;
        						object-fit: cover;
        						
        					}
        					
        				}
        				
                    }
                }
                .swiper-pagination {
                    text-align: left; bottom: 3%; left: 0%;  text-align: center;
                    
                    span {
                        width: 8px; height: 8px;  opacity: 1;background:rgba(191,205,221,0.3); 
                        &.swiper-pagination-bullet-active {
                            background:rgba(191,205,221,0.8); 
                        }
                    }
                }
                
        		.w100{
        			img{
        					position: relative; top: 50%; left: 50%; transform: translate(-50%,-50%);
        				}
        		}
        		
            }
        
        }
        .tips2{
        	position: relative;background:url('../../assets/images/index/tips2_bg1.jpg') no-repeat center;background-size:cover;background-attachment: fixed;
        	.container{
        		width: 72.9%;position: relative;left:0;right:0;top:0;height: 100%;margin: auto;padding:4% 0;
        		display: flex;align-items: center;justify-content: center;
        		@media (max-width: 1024px) {
        		    width: 84%;  
        		}
        		
        	}
        	.text_box{
        		width: 100%;
        		
        		h3{
        			font-size: 43px;color: #ad1f24;position: relative;
        			line-height: 1.8;display: inline-block;
        			&::after{
        				content: '';
        				border-bottom: solid 4px #ad1f24;width: 120px;position: absolute;bottom: 0;left:0;
        			}
        			&:hover{
        				&::after{
        					width: 100%;
        				}
        			}
        		}
        		p{font-size:16px;color: #444;line-height: 30px;margin-top: 30px;}
        		ul{
        			display: flex;justify-content: space-between;
        			li{width: 32%;text-align: center;border: solid 1px #eee;padding: 5% 0;
        				p{margin-top: 0;white-space: nowrap;color: #444;}
        				font-size:16px;color: #444;
        				span{font-size: 30px;}
        				&:hover{
        					color: #fff;background: #ad1f24;
        					p{color: #fff;}
        				}
        			}
        		}
        	}
        }
        .tips3{
        	background: #ad1f24;padding: 5vw 0;
        	h3{
        		font-size: 43px;margin-bottom: 2.5vw;
        		color: #fff;position: relative;line-height: 1.8;display: inline-block;
        		&::after{
        			content: '';
        			border-bottom: solid 4px #fff;width: 120px;position: absolute;bottom: 0;left:0;
        		}
        		&:hover{
        			&::after{
        				width: 100%;
        			}
        		}
        	}
        	.tips3List{
        		display: flex;flex-wrap: wrap;
        		li{width: 30%;margin-bottom: 60px;margin-right: 5%;
        			&:nth-child(3n){
        				margin-right: 0;
        			}
        			.text_bottom{background: #fff;padding: 28px;height: 290px;position: relative;
        				.tips3_text{
        					h4{font-size: 24px;color: #000;line-height: 1.5;
        					margin-bottom: 16px;white-space: nowrap;
        					overflow: hidden;text-overflow:ellipsis;}
        					p{font-size: 14px;color: #666;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 7;-webkit-box-orient: vertical;
        					line-height: 20px;}
        					@media (max-width: 1440px) {
        					    h4{font-size: 20px;}
        						p{font-size: 13px;color: #666;line-height: 20px;}
        						
        					}
        					
        				}
        				.buttom{
        					position: absolute;left: 28px;bottom: 28px;display: flex;cursor: pointer;
        					span{line-height: 26px;color: #ad1f24;border: solid 2px #ad1f24;display: inline-block;
        						padding: 0 14px;margin-left: 4px;
        					}
        					&:hover{
        						span{background: #ad1f24;color: #fff;}
        					}
        				}
        			}
        		}
        	}
        }
        .tips_boxz{background:url('../../assets/images/index/tips7_bg.jpg') no-repeat center;background-attachment: fixed;background-size: cover;}
        .tips4{
        	padding: 6vw 0;
        	.container{
        		width: 72.9%;position: relative;left:0;right:0;top:0;height: 100%;margin: auto;
        		display: flex;align-items: center;
        		@media (max-width: 1024px) {
        		    width: 84%;  
        		}
        		
        	}
        	.text_box{
        		width: 100%;
        		h3{
        			font-size: 43px;color: #ad1f24;position: relative;
        			line-height: 1.8;display: inline-block;
        			&::after{
        				content: '';
        				border-bottom: solid 4px #ad1f24;width: 120px;position: absolute;bottom: 0;left:0;
        			}
        			&:hover{
        				&::after{
        					width: 100%;
        				}
        			}
        		}
        		.swiper5{
        			
        			.swiper-slide{text-align: center;padding-top: 60px;
        				p{height: 70px;line-height: 70px;text-align: center;font-size:24px;color: #fff;background: #ad1f24;}
        				
        				
        				&:hover{
        					
        					p{color: #ad1f24;background: #fff;height: 70px;box-shadow: 5px 0 27px #ccc;}
        				}
        			}
        		}
        	}
        }
        
        .tips5{background: url('../../assets/images/index/tips8_bg.jpg') no-repeat center right;background-size: cover
        ;padding: 6vw 0;
        	h3{
        		font-size: 43px;margin-bottom: 2.5vw;display: inline-block;
        		color: #ad1f24;position: relative;line-height: 1.8;
        		&::after{
        			content: '';
        			border-bottom: solid 4px #ad1f24;width: 120px;position: absolute;bottom: 0;left:0;
        		}
        		&:hover{
        			&::after{
        				width: 100%;
        			}
        		}
        	}
        	.img_box{display: flex;justify-content: space-between;
        		.tips5_1{width: 48.4%;overflow: hidden;
        			
        		}
        		.tips5_2{width: 50%;}
        		.tips5_img{position: relative;
        			p{
        				font-size: 24px;color: #fff;
        				position: absolute;left:0;text-align: center;width: 100%;
        				top:50%;z-index: 99;margin-top: -12px;
        			}
        		}
        		.tips5_img_top{margin-bottom: 2.9%;}
        	}
        }
        .tips7{background: #ad1f24;padding: 6vw 0;position: relative;overflow: hidden;
            .swiper-button-prev{left: 7%;}
            .swiper-button-next{right: 7%;}
            .swiper-button-prev,.swiper-button-next{
            	z-index: 999;
            	position: absolute;top:calc(63% - 35px);z-index: 9;
            	border: solid 3px rgba(255, 255, 255, 0.8);width: 70px;height: 70px;text-align: center;line-height: 70px;border-radius: 50%;
            }
            .swiper-button-prev::after{
            	
            	content: "prev"!important;font-family: 'swiper-icons';
            }
            .swiper-button-next::after{
            	content: "next"!important;font-family: 'swiper-icons';
            }
            
        	h3{
        		font-size: 43px;margin-bottom: 2.5vw;display: inline-block;
        		color: #fff;position: relative;line-height: 1.8;
        		&::after{
        			content: '';
        			border-bottom: solid 4px #fff;width: 120px;position: absolute;bottom: 0;left:0;
        		}
        		&:hover{
        			&::after{
        				width: 100%;
        			}
        		}
        	}
        	p{
        		font-size: 16px;line-height: 2;color: #fff;margin-bottom: 3vw;
        	}
            .lear_more{display: inline-block;width:160px;height: 30px;line-height: 30px;text-align: center;font-size:20px;color: #fff;background: #cfa000;border-radius: 5px;margin-top: 3vw;float: right;}
        }
        .tips6{
        	position: relative;
        	
        	.container{
        		width: 72.9%;position: absolute;left:0;right:0;top:0;height: 100%;margin: auto;
        		display: flex;align-items: center;
        		@media (max-width: 1024px) {
        		    width: 84%;  
        		}
        		
        	}
        	.text_box{
        		width: 100%;
        		h3{
        			font-size: 43px;color: #ad1f24;position: relative;
        			line-height: 1.8;display: inline-block;
        			&::after{
        				content: '';
        				border-bottom: solid 4px #ad1f24;width: 120px;position: absolute;bottom: 0;left:0;
        			}
        			&:hover{
        				&::after{
        					width: 100%;
        				}
        			}
        		}
        		ul{
        			display: flex;justify-content: space-between;
        			li{width: 32%;text-align: center;margin-top: 60px;cursor: pointer;
        				padding-right: 1%;
        				background: url('../../assets/images/index/line.png') no-repeat center right;
        				&:last-child{background: none;padding-right: 0;}
        				img{height: 115px;width: auto;margin: auto;}
        				h4{font-size: 24px;color: #000;margin: 30px auto 15px;}
        				p{line-height: 20px;font-size:14px;text-align: left;color: #666;}
        				&:hover{
        					img{animation: jump 0.5s ease-in-out infinite;}
        					
        				}
        				
        				
        			}
        		}
        	}
        }	
        h3{font-size: 36px;color: #000;}
        
    }
	
</style>